import type { RootStore } from '../types';

export const selectPersona = (state: RootStore) => state.ux.persona;

export const selectLegacyPersona = (state: RootStore) =>
  state.ux._legacy_persona;
